module.exports = __webpack_public_path__ + "static/media/elements_section1.26792e6e.png";